import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/estatus';
import Estatus from './EstatusList';


const ms2p = (state) => {
  return {
    ...state.rs_estatus,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Estatus);
